export interface PurchaseContractLineQuickCreate {
  purchaseContractHeaderId: string;
  productId: string;
  description: string;
  quantity: number;
  price: number;
}
